export const allEmojis = [
  {
    name: 'ok',
    char: '👌',
    code: '&#128076;',
    src: require('@/emoji/images/emoji_ok.png'),
    text: 'emoji_ok',
    textSrc: '@/emoji/images/emoji_ok.png'
  },
  {
    name: '爱心',
    char: '❤️',
    code: '❤️',
    src: require('@/emoji/images/emoji_aixin.png'),
    text: 'emoji_aixin',
    textSrc: '@/emoji/images/emoji_aixin.png'
  },
  {
    name: '爱心',
    char: '❤',
    code: '❤',
    src: require('@/emoji/images/emoji_aixin.png'),
    text: 'emoji_aixin',
    textSrc: '@/emoji/images/emoji_aixin.png'
  },
  {
    name: '擦汗',
    char: '😓',
    code: '&#128531;',
    src: require('@/emoji/images/emoji_cahan.png'),
    text: 'emoji_cahan',
    textSrc: '@/emoji/images/emoji_cahan.png'
  },
  {
    name: '沉思',
    char: '😔',
    code: '&#128532;',
    src: require('@/emoji/images/emoji_chensi.png'),
    text: 'emoji_chensi',
    textSrc: '@/emoji/images/emoji_chensi.png'
  },
  {
    name: '大哭',
    char: '😭',
    code: '&#128557;',
    src: require('@/emoji/images/emoji_daku.png'),
    text: 'emoji_daku',
    textSrc: '@/emoji/images/emoji_daku.png'
  },
  {
    name: '大眼',
    char: '🙄️',
    code: '&#128580;',
    src: require('@/emoji/images/emoji_dayan.png'),
    text: 'emoji_dayan',
    textSrc: '@/emoji/images/emoji_dayan.png'
  },
  {
    name: '蛋糕',
    char: '🎂',
    code: '&#127874;',
    src: require('@/emoji/images/emoji_dangao.png'),
    text: 'emoji_dangao',
    textSrc: '@/emoji/images/emoji_dangao.png'
  },
  {
    name: '得意',
    char: '😎',
    code: '&#128526;',
    src: require('@/emoji/images/emoji_deyi.png'),
    text: 'emoji_deyi',
    textSrc: '@/emoji/images/emoji_deyi.png'
  },
  {
    name: '飞吻',
    char: '😘',
    code: '&#128536;',
    src: require('@/emoji/images/emoji_feiwen.png'),
    text: 'emoji_feiwen',
    textSrc: '@/emoji/images/emoji_feiwen.png'
  },
  //   {
  //     name: '愤怒',
  //     char: '😠',
  //     code: '&#128544;',
  //     src: require('@/emoji/images/emoji_fennu.png'),
  //     text: 'emoji_fennu',
  //     textSrc: '@/emoji/images/emoji_fennu.png',
  //   },
  {
    name: '咖啡',
    char: '☕️',
    code: '☕️',
    src: require('@/emoji/images/emoji_kafei.png'),
    text: 'emoji_kafei',
    textSrc: '@/emoji/images/emoji_kafei.png'
  },
  {
    name: '咖啡',
    char: '☕',
    code: '☕',
    src: require('@/emoji/images/emoji_kafei.png'),
    text: 'emoji_kafei',
    textSrc: '@/emoji/images/emoji_kafei.png'
  },
  {
    name: '困倦',
    char: '😪',
    code: '&#128554;',
    src: require('@/emoji/images/emoji_kunjuan.png'),
    text: 'emoji_kunjuan',
    textSrc: '@/emoji/images/emoji_kunjuan.png'
  },
  {
    name: '礼物',
    char: '🎁',
    code: '&#127873;',
    src: require('@/emoji/images/emoji_liwu.png'),
    text: 'emoji_liwu',
    textSrc: '@/emoji/images/emoji_liwu.png'
  },
  {
    name: '茫然',
    char: '😳',
    code: '&#128563;',
    src: require('@/emoji/images/emoji_mangran.png'),
    text: 'emoji_mangran',
    textSrc: '@/emoji/images/emoji_mangran.png'
  },
  {
    name: '玫瑰',
    char: '🌹',
    code: '&#127801;',
    src: require('@/emoji/images/emoji_meigui.png'),
    text: 'emoji_meigui',
    textSrc: '@/emoji/images/emoji_meigui.png'
  },
  {
    name: '破涕为笑',
    char: '😂',
    code: '&#128514;',
    src: require('@/emoji/images/emoji_kuxiao.png'),
    text: 'emoji_kuxiao',
    textSrc: '@/emoji/images/emoji_kuxiao.png'
  },
  {
    name: '强',
    char: '👍',
    code: '&#128077;',
    src: require('@/emoji/images/emoji_qiang.png'),
    text: 'emoji_qiang',
    textSrc: '@/emoji/images/emoji_qiang.png'
  },
  {
    name: '伸舌头',
    char: '😜',
    code: '&#128540;',
    src: require('@/emoji/images/emoji_shenshetou.png'),
    text: 'emoji_shenshetou',
    textSrc: '@/emoji/images/emoji_shenshetou.png'
  },
  {
    name: '胜利',
    char: '✌️',
    code: '✌️',
    src: require('@/emoji/images/emoji_shengli.png'),
    text: 'emoji_shengli',
    textSrc: '@/emoji/images/emoji_shengli.png'
  },
  {
    name: '胜利',
    char: '✌',
    code: '✌',
    src: require('@/emoji/images/emoji_shengli.png'),
    text: 'emoji_shengli',
    textSrc: '@/emoji/images/emoji_shengli.png'
  },
  //   {
  //     name: '睡觉',
  //     char: '😴',
  //     code: '&#128564;',
  //     src: require('@/emoji/images/emoji_shuijiao.png'),
  //     text: 'emoji_shuijiao',
  //     textSrc: '@/emoji/images/emoji_shuijiao.png',
  //   },
  {
    name: '松口气',
    char: '😌',
    code: '&#128524;',
    src: require('@/emoji/images/emoji_songkouqi.png'),
    text: 'emoji_songkouqi',
    textSrc: '@/emoji/images/emoji_songkouqi.png'
  },
  {
    name: '吐舌',
    char: '😝',
    code: '&#128541;',
    src: require('@/emoji/images/emoji_tushe.png'),
    text: 'emoji_tushe',
    textSrc: '@/emoji/images/emoji_tushe.png'
  },
  {
    name: '微笑',
    char: '☺',
    code: '☺',
    src: require('@/emoji/images/emoji_weixiao.png'),
    text: 'emoji_weixiao',
    textSrc: '@/emoji/images/emoji_weixiao.png'
  },
  //   {
  //     name: '握手',
  //     char: '🤝',
  //     code: '&#129309;',
  //     src: require('@/emoji/images/emoji_woshou.png'),
  //     text: 'emoji_woshou',
  //     textSrc: '@/emoji/images/emoji_woshou.png',
  //   },
  {
    name: '喜欢',
    char: '😍',
    code: '&#128525;',
    src: require('@/emoji/images/emoji_xihuan.png'),
    text: 'emoji_xihuan',
    textSrc: '@/emoji/images/emoji_xihuan.png'
  },
  {
    name: '愉快',
    char: '😊',
    code: '&#128522;',
    src: require('@/emoji/images/emoji_yukuai.png'),
    text: 'emoji_yukuai',
    textSrc: '@/emoji/images/emoji_yukuai.png'
  },
  {
    name: '眨眼',
    char: '😉',
    code: '&#128521;',
    src: require('@/emoji/images/emoji_zhayan.png'),
    text: 'emoji_zhayan',
    textSrc: '@/emoji/images/emoji_zhayan.png'
  }
  //   {
  //     name: '龇牙',
  //     char: '😄',
  //     code: '&#128513;',
  //     src: require('@/emoji/images/emoji_ziya.png'),
  //     text: 'emoji_ziya',
  //     textSrc: '@/emoji/images/emoji_ziya.png',
  //   },
  //   {
  //     name: '龇牙', char: '😄', code: '&#128516;', src: require('@/emoji/images/emoji_ziya.png'), text: 'emoji_ziya', textSrc: '@/emoji/images/emoji_ziya.png'
  //   }
];

export const emojiList = () => allEmojis;

export const emojis = () => {
  const list = new Map();
  return allEmojis.filter((e) => !list.has(e.name) && list.set(e.name, 1));
};

// emoji 转码
export function utf16toEntities(str: any) {
  // eslint-disable-next-line no-param-reassign
  str = str ? str.toString() : '';
  const patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
  // eslint-disable-next-line no-param-reassign
  str = str.replace(patt, (char: any) => {
    let H;
    let L;
    let code;
    if (char.length === 2) {
      H = char.charCodeAt(0); // 取出高位
      L = char.charCodeAt(1); // 取出低位
      code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
      return `&#${code};`;
    }
    return char;
  });
  return str;
}

// emoji 解码
export function uncodeUtf16(str: any) {
  // eslint-disable-next-line no-param-reassign
  str = str ? str.toString() : '';
  // eslint-disable-next-line no-useless-escape
  const reg = /\&#.*?;/g;
  const result = str.replace(reg, (char: any) => {
    let H;
    let L;
    let code;
    if (char.length === 9) {
      // eslint-disable-next-line radix
      code = parseInt(char.match(/[0-9]+/g));
      H = Math.floor((code - 0x10000) / 0x400) + 0xd800;
      // eslint-disable-next-line no-mixed-operators
      L = ((code - 0x10000) % 0x400) + 0xdc00;
      return unescape(`%u${H.toString(16)}%u${L.toString(16)}`);
    }
    return char;
  });
  return result;
}
